import React, { useRef, useState, useEffect } from "react";
import Button from "components/CustomButton";
import { ReactComponent as ArrowRight } from "assets/img/icons/thoughtArrowRight.svg";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useFormik } from "formik";
import CustomInput from "components/CustomInput/CustomInput.js";
import * as Yup from "yup";

var styles = {
  root: {
    overflow: "hidden",
    position: "absolute",
    zIndex: "999999999",
    color: "white",
    width: "0%",
    overflowX: "hidden",
    transition: " 0.5s",
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    bottom: "0",
  },
  content: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "400",
    padding: "0px 0px 15px",
  },
  cancelDialog: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 15px",
  },
  slideShowTopic: {
    backgroundColor: "white",
    color: "black",
    padding: "10px",
    margin: "0 15px",
    borderRadius: "5px",
  },
  formControl: {
    backgroundColor: "white",
    margin: "9px 15px",
    padding: "28px 21px",
    width: "-webkit-fill-available",
    borderRadius: "5px",
  },
  addButton: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "12px",
  },
  cancelButton: {
    width: "30px",
    fill: "white",
  },
  thoughtButton: {
    width: "35px",
    height: "35px",
    background: "#434343",
    fill: "white",
    borderRadius: "50%",
    padding: "5px",
    boxShadow: "0 1px 8px 0 rgb(0 0 0 / 20%), 0 4px 23px 0 rgb(0 0 0 / 19%)",
  },
  thoughtButtonRoot: {},
};

export default ({ initialResponse = null, setCaption, heading = "Image" }) => {
  const classes = styles;
  const [showThoughtDialog, setShowThoughtDialog] = useState(false);
  const dialogEl = useRef(null);

  useEffect(() => {
    if (!showThoughtDialog) {
      return;
    }
    dialogEl.current.style.width = "100%";
  }, [showThoughtDialog]);

  const formik = useFormik({
    initialValues: {
      thought: "",
    },
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      thought: Yup.string().max(5000).required(),
    }),
    onSubmit: async (values) => {
      setCaption(values.thought);
      closeDialog();
    },
  });

  const showDialog = () => {
    setShowThoughtDialog(true);
  };

  const closeDialog = () => {
    dialogEl.current.style.width = "0%";
    setTimeout(() => {
      setShowThoughtDialog(false);
    }, 1000);
    return;
  };

  return (
    <>
      <span className="arrowThoughtButton" style={classes.thoughtButtonRoot}>
        <ArrowRight onClick={showDialog} style={classes.thoughtButton} />
      </span>
      {showThoughtDialog && (
        <div style={classes.root} ref={dialogEl}>
          <div style={classes.cancelDialog}>
            <CancelIcon onClick={closeDialog} style={classes.cancelButton} />
          </div>
          <div style={classes.content}>Your {heading} has been saved</div>
          <div>
            <div style={classes.slideShowTopic}>
              {initialResponse?.data?.topic}
            </div>
            <form noValidate onSubmit={formik.handleSubmit}>
              <CustomInput
                id="name"
                formGroup={false}
                style={classes.formControl}
                placeholder="Updates, Thoughts"
                inputProps={{
                  type: "text",
                  ...formik.getFieldProps("thought"),
                  error: formik.errors.thought,
                }}
              />
              <div style={classes.addButton}>
                <Button buttonClass={"grad_btn join-btn"}>Add Thought</Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
